/** Grymwyrd Italian copy for the Play / VTT feature. */
export const playIt = {
  // CampaignList
  'play.campaigns.heading': 'Le Mie Campagne',
  'play.campaigns.signIn': 'Accedi',
  'play.campaigns.signInToSee': 'per vedere le campagne a cui ti sei unito.',
  'play.campaigns.fallbackNotice': 'Mostrando campagne di esempio — la tua lista non ha potuto essere caricata.',
  'play.campaigns.loading': 'Ricordando le tue saghe…',
  'play.campaigns.empty': 'Non ti sei ancora unito a nessuna campagna.',
  'play.campaigns.assignedCharacter': 'Personaggio Assegnato',
  'play.campaigns.unassigned': 'Non Assegnato',
  'play.campaigns.noCharactersYet': 'Nessun personaggio ancora',
  'play.campaigns.enterCampaign': 'Entra nella campagna',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'Il Tavolo',
  'play.vtt.launch': 'Avvia VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — campagna {campaignId}',
  'play.vtt.veilHeadline': 'Il velo fra il tavolo e la storia è sottile qui.',
  'play.vtt.prototypeIntro':
    'Il tavolo virtuale in tempo reale è una fase successiva. Il prototipo interattivo si incorporerà in questo frame — premi',
  'play.vtt.prototypeOutro': 'per preparare il contenitore.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Ricerca Veloce nel Codex',
  'play.codex.searchPlaceholder': 'Cerca un mostro, un incantesimo, una regola…',
  'play.codex.searchAriaLabel': 'Cerca nell\'enciclopedia',
  'play.codex.searching': 'Scrutando…',
  'play.codex.noResults': 'Nulla trovato per "{q}".',
  'play.codex.hint': 'Digita almeno due lettere per cercare nell\'enciclopedia vivente senza lasciare il tuo tavolo.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Campagna',
  'play.campaign.fallbackDescription':
    'I dettagli della campagna non hanno potuto essere caricati — puoi comunque preparare il tuo personaggio qui sotto.',
  'play.campaign.seoTitle': 'Campagna',
  'play.campaign.noneSpecified': 'Nessuna campagna specificata.',
  'play.campaign.seoTitleNamed': '{title} — Gioca',
  'play.campaign.seoTitleDefault': 'Campagna — Gioca',
  'play.campaign.backToLobby': 'Torna alla lobby',
  'play.campaign.gm': 'DM {gm}',
  'play.campaign.playersCount': '{count} giocatori',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Salvato nel tuo codex.',
  'play.sheet.savedLocally': 'Salvato localmente (server non disponibile).',
  'play.sheet.saveError': 'Non è stato possibile salvare il tuo personaggio — l\'archiviazione non è disponibile.',
  'play.sheet.loading': 'Dispiegando il foglio…',
  'play.sheet.heading': 'Foglio del Personaggio',
  'play.sheet.avatarAlt': 'Avatar di {name}',
  'play.sheet.unclaimedHero': 'Eroe non reclamato',
  'play.sheet.abilityCheck': 'Prova di {ability} ({formula}):',
  'play.sheet.name': 'Nome',
  'play.sheet.namePlaceholder': 'Viandante senza nome',
  'play.sheet.level': 'Livello',
  'play.sheet.speciesLabel': 'Stirpe / Specie',
  'play.sheet.loadingOption': 'Caricamento…',
  'play.sheet.selectSpecies': 'Seleziona specie',
  'play.sheet.classLabel': 'Classe',
  'play.sheet.selectClass': 'Seleziona classe',
  'play.sheet.abilityScores': 'Modificatori di Abilità',
  'play.sheet.abilityScoresHint': '(clicca il modificatore per tirare)',
  'play.sheet.abilityScoreAria': 'Modificatore {ability}',
  'play.sheet.rollCheckAria': 'Tira una prova di {ability}',
  'play.sheet.hp': 'PV',
  'play.sheet.maxHp': 'PV Max',
  'play.sheet.ac': 'CA',
  'play.sheet.backstory': 'Retroscena',
  'play.sheet.backstoryPlaceholder': 'Quale oscurità ha portato questa anima al tavolo?',
  'play.sheet.canonCandidate': 'Candidato al Canone',
  'play.sheet.canonCandidateHint': 'Iscriviti per considerare questo personaggio come parte del canone vivente di Grymwyrd.',
  'play.sheet.saving': 'Salvando…',
  'play.sheet.saveCharacter': 'Salva Personaggio',

  // CreateGameModal
  'play.create.errorNoName': 'Dai un nome al tuo tavolo.',
  'play.create.errorNoSystem': 'Scegli un sistema di gioco.',
  'play.create.you': 'Tu',
  'play.create.errorCreate': 'Il rituale è fallito — il tuo tavolo non ha potuto essere creato. Riprova tra poco.',
  'play.create.modalTitle': 'Convoca un Tavolo',
  'play.create.successCopy': 'Il tuo tavolo è pronto. Condividi questo link di invito per evocare i tuoi giocatori.',
  'play.create.copyInviteAria': 'Copia link di invito',
  'play.create.copied': 'Copiato',
  'play.create.copy': 'Copia',
  'play.create.done': 'Fatto',
  'play.create.tableName': 'Nome del Tavolo',
  'play.create.tableNamePlaceholder': 'es. La Volta del Lamento',
  'play.create.quickStart': 'Avvio Rapido',
  'play.create.quickStartAria': 'Preset di avvio rapido',
  'play.create.customPreset': 'Personalizzato',
  'play.create.customPresetDesc': 'Inizia da zero',
  'play.create.gameSystem': 'Sistema di Gioco',
  'play.create.loadingSystems': 'Caricamento sistemi…',
  'play.create.systemFromPreset': '{system} (dal preset)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (predefinito)',
  'play.create.tags': 'Etichette',
  'play.create.tagsUpTo': '(fino a {count})',
  'play.create.removeTagAria': 'Rimuovi etichetta {tag}',
  'play.create.tagLimitReached': 'Limite di etichette raggiunto',
  'play.create.tagPlaceholder': 'horror, one-shot…',
  'play.create.maxPlayers': 'Max Giocatori:',
  'play.create.cancel': 'Annulla',
  'play.create.convening': 'Convocando…',
  'play.create.createTable': 'Crea Tavolo',

  // JoinPage
  'play.join.finding': 'Cercando il tavolo…',
  'play.join.expiredHeading': 'Questo invito è scaduto',
  'play.join.expiredBody': 'I codici scadono per sicurezza. Chiedi al tuo ospite uno fresco.',
  'play.join.browseLiveTables': 'Sfoglia tavoli attivi',
  'play.join.errorHeading': 'Non abbiamo potuto raggiungere il tavolo',
  'play.join.errorBody': 'Qualcosa è andato storto nel cercare il tuo invito. Controlla la tua connessione e riprova.',
  'play.join.tryAgain': 'Riprova',
  'play.join.defaultTableTitle': 'Un tavolo Grymwyrd',
  'play.join.invited': 'Sei stato invitato a prendere posto.',
  'play.join.signInToSeat': 'Accedi per prendere il tuo posto',
  'play.join.createAccount': 'Nuovo qui? Crea un account gratuito',
  'play.join.opensAfterSignIn': 'Il tavolo si apre dopo aver effettuato l\'accesso.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Gioca — Tavolo Virtuale',
  'play.lobby.seoDescription':
    'Trova un tavolo, unisciti a una sessione dal vivo e forgia la tua leggenda al tavolo virtuale di Grymwyrd.',
  'play.lobby.eyebrow': 'Tavolo Virtuale',
  'play.lobby.title': 'Gioca',
  'play.lobby.subtitle':
    'Raduna il tuo coven. Tira i dadi. Prendi posto a un tavolo dove ogni scelta risuona nel canone vivente di Grymwyrd.',
  'play.lobby.createGame': 'Crea Gioco',
  'play.lobby.playNow': 'Gioca Ora — nessun account necessario',
  'play.lobby.signInToHost': 'Accedi per ospitare il tuo tavolo',

  // SessionListLive
  'play.live.heading': 'In Diretta Ora',
  'play.live.empty': 'Nessun tavolo è attivo in questo momento. Il velo è tranquillo — inizia il tuo.',
  'play.live.badge': 'In Diretta',
  'play.live.unknownSystem': 'Sistema sconosciuto',
  'play.live.gmSuffix': ' · DM {gm}',
  'play.live.players': 'giocatori',

  // TableList — empty board
  'play.tables.emptyHeading': 'Nessun tavolo aperto ancora',
  'play.tables.emptyBody':
    'La lavagna è tranquilla per ora. Sii il primo a tirare su una sedia — prova il tavolo ospite all\'istante, nessun account necessario.',
  'play.tables.tryGuestTable': 'Prova il tavolo ospite',
  'play.tables.orUse': 'O usa',
  'play.tables.createGame': 'Crea Gioco',
  'play.tables.aboveToHost': 'sopra per ospitare il tuo.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Non è stato possibile unirti alla lista d\'attesa — riprova.',
  'play.waitlist.leaveError': 'Non è stato possibile lasciare la lista d\'attesa — riprova.',
  'play.waitlist.join': 'Unisciti alla lista d\'attesa',
  'play.waitlist.leaving': 'Lasciando…',
  'play.waitlist.leave': 'Lascia la lista d\'attesa',
  'play.waitlist.joining': 'Unendosi…',

  // TableList — board
  'play.tables.heading': 'Tavoli Aperti',
  'play.tables.openSeatOnly': 'Solo posti aperti',
  'play.tables.systemFilterPlaceholder': 'Sistema…',
  'play.tables.systemFilterAria': 'Filtra per sistema',
  'play.tables.tagsFilterPlaceholder': 'Etichette (separate da virgola)…',
  'play.tables.tagsFilterAria': 'Filtra per etichette',
  'play.tables.fetchError': 'Non è stato possibile raggiungere la bacheca dal vivo — la lobby è temporaneamente non disponibile.',
  'play.tables.loading': 'Radunando tavoli…',
  'play.tables.untitledTable': 'Tavolo senza titolo',
  'play.tables.full': 'Pieno',
  'play.tables.seatedCount': '{count} seduti',
  'play.tables.viewTable': 'Visualizza Tavolo',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Chat del Tavolo',
  'chat.empty': 'Nessun messaggio ancora. Scrivi qualcosa al tavolo.',
  'chat.inputPlaceholder': 'Messaggio al tavolo…',
  'chat.inputAria': 'Messaggio di chat',
  'chat.send': 'Invia',
  'chat.translatedFrom': 'Tradotto da {lang}',
  'chat.original': 'Originale',
  'chat.showOriginal': 'Mostra originale',
  'chat.showTranslation': 'Mostra traduzione',
  'chat.showOriginalsAll': 'Mostra originali',
  'chat.showTranslationsAll': 'Mostra traduzioni',
};
